/**
 * Url Formatter.
 */
window.urlFormatter = function(value) {
    if (value) {
        return '<a href="'+value+'" target="_blank" rel="noopener noreferrer">'+value+"</a>";
    }
};
